import { useMemo } from "react";
import className from "classnames/bind";
import { Button, Container, Image, TypePill } from "@components";
import { GetNextUpPostQuery } from "@graphqlTypes";

import styles from "./NextUpStory.module.scss";
import { getHighlightMarkup } from "@/core/utils";
import { usePageWrapperData } from "@/providers/PageWrapperContext";
const cx = className.bind(styles);

export default function NextUpStory({ featureData, uri }: GetNextUpPostQuery["nextUpStory"]) {
  const { headline, tracks } = featureData?.sonicConnections || {};
  const headlineMarkup = getHighlightMarkup(headline);
  const { labels } = usePageWrapperData();
  const { nextStoryHeadline, nextStoryButton } = labels || {};
  const trackImages = useMemo(() => {
    return tracks?.map((track) => track?.heroImage) || [];
  }, [tracks]);

  const dedupedTracks = useMemo(() => {
    return trackImages.filter(
      (value, index, self) =>
        self.findIndex(
          (el) => value?.node?.mediaItemUrl === el?.node?.mediaItemUrl
        ) === index
    );
  }, [trackImages]);

  return (
    <section className={cx(["next-up-story"])}>
      <Container>
        <h2 className={cx(["title-uc-xxxxl center", "next-up-title"])}>
          {nextStoryHeadline}
        </h2>
      </Container>
      <ul className={cx("next-up-images")}>
        {dedupedTracks?.map((heroImage, index) => (
          <li key={index}>
            <Image image={heroImage} />
          </li>
        ))}
      </ul>
      <Container className={cx("next-up-story-text")}>
        <div className={cx("next-up-story-text-content")}>
          <TypePill type="post" copy={labels?.postTypeLabels?.post} />

          <h2
            className="title-uc-l"
            dangerouslySetInnerHTML={{ __html: headlineMarkup }}
          />
          <Button label={nextStoryButton} url={uri} />
        </div>
      </Container>
    </section>
  );
}
